import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faBars, faHeart, faReply, faRocket, faStickyNote, faUsers, faColumns, 
    faComments, faChessKnight, faBug, faSpinner, faAmericanSignLanguageInterpreting,
    faExclamationTriangle, faDiagnoses, faPaperclip, faTrash, faEdit, faPen,
    faInbox, faEnvelopeOpen, faImage
} from '@fortawesome/free-solid-svg-icons'

library.add(faBars, faHeart, faReply, faRocket, faStickyNote, faUsers, faColumns, faComments, faChessKnight, faBug, faSpinner);
library.add(faAmericanSignLanguageInterpreting, faExclamationTriangle, faDiagnoses, faPaperclip, faTrash, faEdit, faPen);
library.add(faInbox, faEnvelopeOpen, faImage);


// WEBPACK FOOTER //
// ./src/fa.js